export default __webpack_public_path__ + "static/media/feedback-sender.cd700973.svg";